// extracted by mini-css-extract-plugin
export default {"icon":"backLink_icon__2Aack"};